import * as React from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { styles } from "../../views/OrderDetailsView.styles";
import { useTranslation } from "react-i18next";
import { BlueButton } from "../Buttons/BlueButton";

export interface IKaikoDetailsComponentProps extends WithStyles<typeof styles> {
    dates: any,
    exchanges: any[],
    currencies: any[]
}

const KaikoDetailsComponentPure: React.FunctionComponent<IKaikoDetailsComponentProps> = ({ classes, dates, exchanges, currencies }: IKaikoDetailsComponentProps) => {

    const {t} = useTranslation();

    const [openDetails, setOpenDetails] = React.useState(false);

    const [scrollPopWindow, setScrollPopWindow] = React.useState();

    const handleClickOpen = (scrollType) => () => {
        setOpenDetails(true);
        setScrollPopWindow(scrollType);
    };

    const handleClose = () => {
        setOpenDetails(false);
    };

    const kaikoDetailsRef = React.useRef(null);
    React.useEffect(() => {
        if (openDetails) {
            const {current: descriptionElement} = kaikoDetailsRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [openDetails]);

    return <>
        <Typography variant="body2" className={classes.link} onClick={handleClickOpen("paper")}>Open selected Kaiko details</Typography>
        <Dialog
            open={openDetails}
            onClose={handleClose}
            scroll={scrollPopWindow}
            fullWidth
            maxWidth={"lg"}
        >
            <DialogTitle>Selected Kaiko order details</DialogTitle>
            <DialogContent dividers={scrollPopWindow === "paper"}>
                <DialogContentText component={"span"}
                                   ref={kaikoDetailsRef}
                                   tabIndex={-1}
                >
                    <Grid container spacing={2} direction="column">
                        <Grid item xs={10}>
                            <Typography variant="h5">Selected Dates:</Typography>
                            <Typography variant="body2">From {dates[0]} to {dates[1]}</Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Typography variant="h5">Selected Exchanges:</Typography>
                            <Typography variant="body2">{exchanges.map(exchange => exchange.name).join(", ")}</Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Typography variant="h5">Selected Assets:</Typography>
                            <Typography variant="body2">{currencies.map(currency => currency.name).join(", ")}</Typography>
                        </Grid>
                    </Grid>                    
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <BlueButton
                    onClick={handleClose}
                >{t("general.close")}</BlueButton>
            </DialogActions>
        </Dialog>
    </>;
};

export const KaikoDetailsComponent = withStyles(styles)(KaikoDetailsComponentPure);
